import { Component, input, signal, computed } from '@angular/core';


@Component({
  selector: 'app-button',
  standalone: true,
  imports: [],
  templateUrl: './app-button.component.html',
  styleUrls: ['./app-button.component.scss'],
})
export class AppButtonComponent {
  variant = input<'primary' | 'ghost' | 'danger' | 'icon'>('primary');

  size = input<'default' | 'form'>('default');

  icon = input<string>('');

  disabled = input<boolean>(false);

  type = input<'button' | 'submit' | 'reset'>('button');

  fullWidth = input<boolean>(false);

  btnClass = computed(() => {
    const v = this.variant();
    const s = this.size();
    const fw = this.fullWidth() ? ' btn--full' : '';
    let classes = `btn btn--${v}`;
    if (s === 'form') classes += ' btn--form';
    classes += fw;
    return classes;
  });
}
